<script setup lang="ts">
import ProjectModuleCTAButton from '@/components/ProjectModuleCTAButton.vue';
import type { Locales, ProjectModuleDto } from '@/services/types/api.types';
import { useI18n } from 'vue-i18n';

const props = withDefaults(
  defineProps<{
    languageEnabled: Locales[];
    blocks: ProjectModuleDto[];
    blockId: number;
    allowModuleLinks?: boolean;
  }>(),
  { allowModuleLinks: true },
);

const { t } = useI18n();
</script>

<template>
  <div>
    <p class="text-h6 q-mt-sm">{{ t('project-module.ctaButtons.title') }}</p>
    <ProjectModuleCTAButton
      name="config.ctaButtons.button1"
      :language-enabled="languageEnabled"
      :label="t('project-module.ctaButtons.primary')"
      :blocks="blocks"
      :block-id="blockId"
      :allow-module-links="allowModuleLinks"
    />
    <ProjectModuleCTAButton
      name="config.ctaButtons.button2"
      :language-enabled="languageEnabled"
      :label="t('project-module.ctaButtons.secondary')"
      :blocks="blocks"
      :block-id="blockId"
      :allow-module-links="allowModuleLinks"
    />
  </div>
</template>
